import { defineStore } from 'pinia'
import { useHealthArticleService } from '@/modules/health_article/service'

export const useHealthArticleStore = defineStore({
    id: 'useHealthArticleStore',
    state: () => ({
        listContentState: null,
        addContentState: null,
        editContentState: null,
        updateContentState: null,
        deleteContentState: null
    }),

    getters: {
        getAllContent(state) {
            return state.listContentState
        },

        getAddContent(state) {
            return state.addContentState
        },

        getEditContent(state) {
            return state.editContentState
        },

        getUpdateContent(state) {
            return state.updateContentState
        },

        getDeleteContent(state) {
            return state.deleteContentState
        }
    },

    actions: {
        async listContentAction(params) {
            const response = await useHealthArticleService.fetchAllContent(params)
            this.listContentState = response
        },

        async addContentAction(params) {
            const response = await useHealthArticleService.fechAddContent(params)
            this.addContentState = response
        },

        async editContentAction(params) {
            const response = await useHealthArticleService.fetchEditContent(params)
            this.editContentState = response
        },

        async updateContentAction(params) {
            const response = await useHealthArticleService.fetchUpdateContent(params)
            this.updateContentState = response
        },

        async deleteContentAction(params) {
            const response = await useHealthArticleService.fetchDeleteContent(params)
            this.deleteContentState = response
        }
    }
})
